<template>
	<span>{{idQuote}}</span>
</template>

<script>
	export default {
		data(){
			return {
				idQuote: null
			}
		},
		created(){
			this.idQuote = this.$route.params.idQuote
		}
	}
</script>